import React, { useEffect, useState } from "react";
import "../styles/Tooltip.scss";

import { format } from "d3-format";

var fmt = format(",");

type TooltipConfig = {
  data: string[] | null;
};

const Tooltip: React.FC<TooltipConfig> = ({ data }) => {
  let tooltipCount = "";
  if (data) {
    tooltipCount = data[1] === "NA" ? "NA" : fmt(+data[1]);
  }

  return data !== null ? (
    <div className="tooltip-container">
      <div className="cd-name">
        <p>{data[0]}</p>
      </div>
      <div className="count">
        <p>
          <span className="prop-label">Count: </span>
          {tooltipCount}
        </p>
      </div>
      <div className="percent">
        <p>
          <span className="prop-label">Percent: </span>
          {(+data[2]).toFixed(1)}%
        </p>
      </div>
    </div>
  ) : null;
};

export default Tooltip;
